import React from 'react'
import cx from 'classnames'
import MuiTableCell from '@mui/material/TableCell'

export default ({ children, cxNames, ...props }) => (
  <MuiTableCell {...props} className={cx(cxNames)} classes={{ root: 'lh-title' }}>
    {children}
  </MuiTableCell>
)
